<template>
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <textarea
          class="w-full"
          rows="40"
          v-model="prettySchema">
        </textarea>

        <vs-button @click="test">Probar</vs-button>
      </div>
      <div class="col-md-6"></div>
    </div>
  </div>
</template>

<script>
import {RiskModel} from "@/services/ModelRisk/RiskModel";

export default {
  name: "Playground",
  data: () => ({
    schema: {}
  }),
  computed: {
    prettySchema() {
      return JSON.stringify(this.schema, null, '\t');
    }
  },
  async mounted() {
    this.schema = await RiskModel
      .admin()
      .schema()
      .get('approve', 1)
  },
  methods: {
    async test() {
      this.schema = await RiskModel
        .approve()
        .test('approve', 1, this.schema)
    }
  }
}
</script>

<style scoped>

</style>
